module.exports = __webpack_public_path__ + "static/media/logo.72cb97f3.svg";